module.exports = __webpack_public_path__ + "img/Path28516.08481355.png";